import React from 'react';
import { useTranslation } from 'react-i18next';

import type { ArtStyleOption } from '../../../../lib/domain-types';
import { Card, Thumb, Image, Ring } from './StyleCard.styles';

export type StyleCardProps = {
  style: ArtStyleOption;
  selected: boolean;
  onClick?: () => void;
};

/** Square art-style thumbnail with a brand selection ring. */
export const StyleCard = ({ style, selected, onClick }: StyleCardProps): React.ReactElement => {
  const { t } = useTranslation();
  return (
    <Card type="button" onClick={onClick} data-ga-id={`cfg-design-style-${style.id}`} aria-label={style.name} title={t('{{name}}', { name: style.name })}>
      <Thumb>{style.image ? <Image src={style.image} alt="" /> : null}</Thumb>
      {selected ? <Ring /> : null}
    </Card>
  );
};

export default StyleCard;
